module.exports = __webpack_public_path__ + "static/media/Markeroftheweek.78039e44.gif";